import React, { useState } from 'react';

/**
 * Editorial newsletter signup used at the end of blog posts.
 * Keeps the same n8n webhook + gtag event as the legacy version — only the
 * markup + styles are redone to match the redesign theme.
 */
const NewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null); // 'success' | 'error'

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;

    try {
      const params = new URLSearchParams({ email, source: 'blog_newsletter' });
      const url = `https://n8n.aakeeocrm.com/webhook/5fed7f08-2230-4d07-a78b-7db4c26c0246?${params.toString()}`;
      await fetch(url, { method: 'GET', mode: 'no-cors' });
      if (typeof gtag === 'function') {
        gtag('event', 'newsletter_signup', {
          event_category: 'lead_capture',
          event_label: 'blog_crm_checklist',
        });
      }
      setStatus('success');
      setEmail('');
    } catch (err) {
      setStatus('error');
    }
    setTimeout(() => setStatus(null), 5000);
  };

  return (
    <aside className="newsletterA">
      <div className="newsletterA-copy">
        <span className="eyebrowA">Free · CRM implementation checklist</span>
        <h3>
          The <em>42-point</em> checklist we ship with every client.
        </h3>
        <p>Data migration, module setup, team training, go-live readiness. The thing we wish every team had before starting a CRM project.</p>
      </div>
      <form className="newsletterA-form" onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="you@company.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          aria-label="Email address"
        />
        <button type="submit" className="btnA-primary">Send me the checklist</button>
      </form>
      {status === 'success' && (
        <p className="newsletterA-note newsletterA-note--ok">Check your inbox — the checklist is on its way.</p>
      )}
      {status === 'error' && (
        <p className="newsletterA-note newsletterA-note--err">Something went wrong. Please try again.</p>
      )}
      <p className="newsletterA-fine">No spam. Unsubscribe in one click.</p>
    </aside>
  );
};

export default NewsletterSignup;
